import React from 'react';
import { Table } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'contexts/AuthContext';
import { AccessType } from 'types/User';
import { StatusDataType } from 'const/statusDefinitions';

interface StatusTableProps {
  className?: string;
  data: readonly string[];
  statusTag?: (status: string) => React.ReactNode;
  statusDefinitions?: string;
  statusTitle: string;
  statusColumnWidthPercent?: number;
}

export default function StatusTable({
  className = '',
  data,
  statusTag,
  statusDefinitions,
  statusTitle,
  statusColumnWidthPercent = 20,
}: StatusTableProps) {
  const { t } = useTranslation();

  const { auth } = useAuthContext();
  const isConcessionnaire =
    auth?.user.accessType === AccessType.CONCESSIONNAIRE;

  const statusData: StatusDataType[] = data.map((status, index) => {
    const statusForDefinition =
      isConcessionnaire &&
      (status === 'ChantierEnCours' ||
        status === 'DocumentsEnAttente' ||
        status === 'Abandon')
        ? `${status}_concession`
        : status;

    return {
      key: index.toString(),
      definition: t(`${statusDefinitions}:${statusForDefinition}`),
      status,
    };
  });

  const columnsStatus = [
    {
      title: t(statusTitle),
      key: 'status',
      dataIndex: 'status',
      width: `${statusColumnWidthPercent}%`,
      render: (status: string) => (statusTag ? statusTag(status) : status),
    },
    {
      title: t('glossaire:definition'),
      key: 'definition',
      dataIndex: 'definition',
      width: `${100 - statusColumnWidthPercent}%`,
    },
  ];

  return (
    <Table
      columns={columnsStatus}
      dataSource={statusData}
      pagination={false}
      bordered
      className={clsx(
        'separate-rows-table blue-header-table radius-sm',
        className,
      )}
    />
  );
}
